/*
 * @Title: 模拟onBlur事件
 * @Author: yanggqm
 * @Date: 2018-07-03 21:06:34
 * @Last Modified by: qiaofan
 * @Last Modified time: 2023-08-15 10:31:45
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import OriginCheckbox from 'bee-checkbox';
import { Checkbox as OriginCheckbox } from "@tinper/next-ui";
import { isArrowKeyDown } from '@platform/api';
import { getSysFieldid } from '@platform/api';

//require('bee-checkbox/build/Checkbox.css');
require('./index.less');
export default class Checkbox extends Component {
    constructor(props) {
        super(props);
        this.isTouch = false;
        this.isOnfocus = false;
        // 添加状态记录  独立使用组件时可以正常使用  --bbqin
        let checked =
            props.type === 'switch' && typeof props.checked === 'string'
                ? props.checked === 'Y'
                : props.checked;
        this.state = { checked: 'checked' in props ? checked : false };
        this.flag = false; // 判断是否让组件自动掉用onchang逻辑
    }

    componentDidMount() {
        document.addEventListener('click', this.outsideClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.outsideClick, true);
    }

    // 监控 props属性的变化 同步到state
    componentWillReceiveProps(nextProps) {
        if ('checked' in nextProps) {
            // 添加状态记录  独立使用组件时可以正常使用  --bbqin
            let checked =
                nextProps.type === 'switch' && typeof nextProps.checked === 'string'
                    ? nextProps.checked === 'Y'
                    : nextProps.checked;
            // console.log(nextProps, this.props)
            // 解决undefined 不能改变checkbox状态的问题
            this.setState({ checked: !!checked });
        }
    }

    getNode = el => {
        this.container = ReactDOM.findDOMNode(el);
    };

    // hanldleClick = (e) => { 改之前的
    // 	typeof this.props.onClick === 'function' && this.props.onClick(e);
    // 	this.isOnfocus = true;
    // }
    testType = origin => {
        return Object.prototype.toString.call(origin).slice(8, -1);
    };

    hanldleClick = e => {
        let self = this;
        if (typeof this.props.onClick === 'function' && !this.props.disabled) {
            let value = this.props.onClick(e);
            if (this.testType(value) === 'Promise') {
                self.flag = true;
                value.then(res => {
                    if (res) {
                        typeof self.props.onChange === 'function' && self.props.onChange(!self.state.checked);
                        self.state.checked = !self.state.checked;
                        self.setState({ checked: !self.state.checked });
                    }
                });
            } else if (this.testType(value) === 'Boolean') {
                self.flag = true;
                if (value) {
                    typeof self.props.onChange === 'function' && self.props.onChange(!self.state.checked);
                    self.state.checked = !self.state.checked;
                    self.setState({ checked: !self.state.checked });
                }
            } else {
                self.flag = false;
            }
        }
        this.isOnfocus = true;
    };

    /**
     * 状态控制
     */
    changeCheck = checked => {
        if (!this.flag) {
            this.state.checked = !!checked;
            this.setState(this.state, () => {
                typeof this.props.onChange === 'function' && this.props.onChange(!!checked);
            });
        }
    };

    // /**
    //  * 状态控制 改之前的
    //  */
    // changeCheck = (checked) => {
    // 	this.setState({ checked: !this.state.checked });
    // 	typeof this.props.onChange === 'function' && this.props.onChange(!this.state.checked);
    // }

    outsideClick = e => {
        // 排除touched 移动端
        if (e.type === 'touchend') {this.isTouch = true;}
        if (e.type === 'click' && this.isTouch) {return;}
        const { onBlur } = this.props;
        const el = this.container;
        if (el && !el.contains(e.target) && this.isOnfocus) {
            if (onBlur && typeof onBlur === 'function') {
                onBlur(this.props.checked, e);
            }
        }
        this.isOnfocus = false;
    };

    render() {
        let { checked, onEnter, fieldid, className = '', hotKeyWithArrow, ...other } = this.props;

        if (this.props.type === 'switch') {
            if (checked === 'Y') {
                checked = true;
            }
            if (checked === 'N') {
                checked = false;
            }
        }

        if (!fieldid) {
            fieldid = null;
            if (this.props.children) {
                if (typeof this.props.children === 'string') {
                    fieldid = this.props.children;
                } else if (this.props.children instanceof Array) {
                    fieldid = this.props.children[0];
                }
            }
        }

        fieldid = getSysFieldid(fieldid);

        // 上面这一段判断其实可以不需要了  后面谁要是维护到可以去除上述逻辑
        // <Checkbox ref={this.getNode} colors="dark" checked={checked} {...other} onClick={this.hanldleClick}  />
        // 原来的方式使用纯props控制checked方式会导致单独使用  外部不传入checked或者不改变checked 当前组件时无法切换状态  --bbqin
        return (
            <span fieldid={fieldid ? `${fieldid}_checkbox` : null} className="base-checkbox-wrapper" >
                <OriginCheckbox
                    onKeyDown={e => {
                        if ([e.keyCode, e.which, e.charCode].find(e => e === 13) || e.key === 'Enter') {
                            onEnter && onEnter({ e });
                        }

                        //按下方向键
                        if (isArrowKeyDown(e)) {
                            hotKeyWithArrow && hotKeyWithArrow({ e });
                        }
                    }}
                    ref={this.getNode}
                    colors="primary"
                    checked={this.state.checked}
                    className={`base-checkbox-hotkey-wrapper nc-checkbox ${className || ''}`}
                    {...other}
                    inverse
                    onClick={this.hanldleClick}
                    onChange={this.changeCheck.bind(this)}
                />
            </span>
        );
    }
}

const defaultProps = { clsPrefix: 'wui-checkbox' };
Checkbox.CheckboxGroup = OriginCheckbox.Group;
Checkbox.Group = OriginCheckbox.Group;
Checkbox.defaultProps = defaultProps;
